<template>
  <div class="root-container-stm">
    <slot name="navbar">
      <navbar
        :logo="logo"
        :is-admin="$allows('administer')"
        :items="navbarItems"
      >
        <template #lang-switcher>
          <language-switcher />
        </template>
        <template #user-info>
          <NavbarMenu v-bind="companyMenu" />
          <button
            v-show="!$settings.hide_guide_btn"
            v-if="$allows('administer')"
            class="btn btn-danger m-1"
            @click="$router.push({ name: `start-guide` })">
            {{ $t('general.setup_guide') }}
          </button>
          <NavbarUser />
        </template>
      </navbar>
    </slot>

    <div class="page-content">
      <Sidebar
        :menu="menuVisible"
        @on:item:click="onMenuItemClick"
        @toggle-expand="onMenuToggleExpand"
      >
        <template #footer>
          <MobileAppLinks />
        </template>
      </Sidebar>
      <div class="content-wrapper">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import AdminLayout from '../stylemix-vue-admin/components/layout/layout-main.vue'
import NavbarCurrency from './NavbarCurrency.vue'
import NavbarDivision from './NavbarDivision.vue'
import LanguageSwitcher from '../language-switcher/LanguageSwitcher.vue'
import Sidebar from './Sidebar.vue'
import MobileAppLinks from './MobileAppLinks.vue'
import NavbarMenu from './NavbarMenu.vue'
import NavbarUser from '../stylemix-vue-admin/components/navbar/NavbarUser.vue'
import Config from '../stylemix-vue-admin/config'
import SidebarPermissionMixin from '../stylemix-vue-admin/mixins/SidebarPermissionMixin'

export default {
  name: 'TheLayout',

  components: {
    LanguageSwitcher,
    MobileAppLinks,
    NavbarMenu,
    NavbarUser,
    Sidebar,
  },

  extends: AdminLayout,
  mixins: [SidebarPermissionMixin],

  data() {
    return {
      companyMenu: {
        title: '',
        items: [],
      },
    }
  },

  computed: {
    menu() {
      const useApiMenu = process.env.VUE_APP_USE_API_MENU === 'true'
      const hasMenu = this.$store.getters['adminMenu/hasMenu']
      const hasError = this.$store.getters['adminMenu/error']
      const applyExpanded = this.$store.getters['adminMenu/applyExpanded']

      if (useApiMenu) {
        if (hasMenu) return this.$store.getters['adminMenu/menu']
        if (hasError) return applyExpanded(Config.sidebarMenu)
        return []
      }
      return applyExpanded(Config.sidebarMenu)
    },
    menuVisible() {
      if (!this.$account) {
        return []
      }

      return this.filterMenuByPermission(this.menu)
    },

    navbarItems() {
      const navbarItems = []

      if (
        this.$allows('administer') &&
        process.env.VUE_APP_MULTI_DIVISION === 'true'
      ) {
        navbarItems.push({
          icon: 'icon-map5',
          component: NavbarDivision,
        })
      }

      navbarItems.push({
        icon: 'icon-coin-euro',
        component: NavbarCurrency,
      })

      return navbarItems
    },

    isCompany() {
      return this.$allows('bookings.serve')// && !this.$allows('administer')
    },
  },

  watch: {
    '$account' (account) {
      if (account) this.ensureApiMenuLoaded()
    }
  },

  created() {
    this.loadCompanyMenu()
    this.ensureApiMenuLoaded()
  },

  methods: {
    loadCompanyMenu() {
      if (!this.isCompany) {
        return
      }
      this.$http.get('settings/company_menu').then(({ data }) => {
        this.companyMenu.title = data.title
        this.companyMenu.items = data.items
      })
    },
    onMenuToggleExpand(item) {
      if (item && item.id) {
        const isTopLevel = this.$store.getters['adminMenu/menu'].some((m) => m.id === item.id)
        if (!item.isOpen && isTopLevel) {
          this.$store.commit('adminMenu/collapseAllExcept', item.id)
        }
        this.$store.commit('adminMenu/toggleExpanded', item.id)
      }
    },
    ensureApiMenuLoaded() {
      if (
        process.env.VUE_APP_USE_API_MENU === 'true' &&
        this.$account &&
        this.$allows('administer') &&
        !this.$store.getters['adminMenu/hasMenu'] &&
        !this.$store.getters['adminMenu/isLoading']
      ) {
        this.$store.dispatch('adminMenu/fetchMenu').catch(() => {})
      }
    },
  },
}
</script>
